/**
 * Airtuerk iptal ceza kuralları — frontend gösterimi.
 * Backend: services/flight_cancellation_policy.py ile uyumlu.
 */

export const AITO_PORTAL_TIERS = [
  { daysLabel: 'Kalkışa 60 gün ve üzeri', penaltyPercent: 50 },
  { daysLabel: 'Kalkışa 59–30 gün', penaltyPercent: 75 },
  { daysLabel: 'Kalkışa 29–21 gün', penaltyPercent: 85 },
  { daysLabel: 'Kalkışa 20–14 gün', penaltyPercent: 90 },
  { daysLabel: 'Kalkışa 13–0 gün', penaltyPercent: 95 },
];

export const AITC_LOWCOST_PENALTY = 95;

/** Airtuerk lowcost listesi (kısmi — tam liste env/backend ile genişletilebilir) */
export const LOWCOST_AIRLINE_CODES = new Set([
  'U2', 'TB', 'X3', 'VY', 'HV', 'GM', '2L', 'FZ', 'DY', 'BQ', 'XY',
  'FR', 'W6', 'EW', 'LS', 'RK', 'TO', 'V7', 'XP', '4U', 'BE', 'WW', 'SY', 'G9', '3O', 'AK',
]);

export function isLowcostAirline(code) {
  return Boolean(code && LOWCOST_AIRLINE_CODES.has(String(code).toUpperCase()));
}

export function getCancellationPolicy(airlineCode) {
  const code = (airlineCode || '').toUpperCase();
  if (isLowcostAirline(code)) {
    return {
      policyType: 'aitc_lowcost',
      policyLabel: 'AITC (Lowcost)',
      airlineCode: code,
      isLowcost: true,
      tiers: [{ daysLabel: 'Her zaman (kalkış tarihinden bağımsız)', penaltyPercent: AITC_LOWCOST_PENALTY }],
      noteTr:
        'Lowcost (AITC) biletlerde iptal cezası kalkış tarihinden bağımsız %95 olarak uygulanır.',
    };
  }
  return {
    policyType: 'aito_portal',
    policyLabel: 'AITO / Portal',
    airlineCode: code || null,
    isLowcost: false,
    tiers: AITO_PORTAL_TIERS,
    noteTr:
      'Standart (AITO / Portal) biletlerde iptal cezası kalkışa kalan süreye göre tablodaki oranlarda uygulanır.',
  };
}

export const HOW_TO_CANCEL_TR =
  'İptal talebinizi PNR kodunuz ve sipariş numaranız ile support@turkishemarket.com adresine iletebilir veya turkishemarket.com destek sayfasından bize ulaşabilirsiniz.';

export const HOW_TO_CANCEL_EN =
  'To cancel, contact support@turkishemarket.com with your PNR and order ID, or use turkishemarket.com support.';
